/**
 * Infographic 抽象元素类型枚举
 */
export const enum ElementTypeEnum {
  Background = 'background',
  Title = 'title',
  Desc = 'desc',
  ItemsGroup = 'items-group',
  ItemIconGroup = 'item-icon-group',
  ItemIcon = 'item-icon',
  ItemLabel = 'item-label',
  ItemDesc = 'item-desc',
  ItemValue = 'item-value',
  ItemIllus = 'item-illus',
  BtnAdd = 'btn-add',
  BtnRemove = 'btn-remove',
  IllusGroup = 'illus-group',
  IllusVolume = 'illus-volume',
  Illus = 'illus',
  BtnsGroup = 'btns-group',

  Unknown = 'unknown',
}
